import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';
import cn from 'classnames';
import Icon from 'components/icon';
import articleTeaserSizes from './article-teaser-sizes';
import { imageSourceBreakpoints } from 'js/breakpoints';

const getImageSources = teaserSize => {
  switch (teaserSize) {
    case articleTeaserSizes.small:
      return [
        { width: 386, height: 282, media: imageSourceBreakpoints.xs },
        { width: 226, height: 165, media: imageSourceBreakpoints.s },
        { width: 288, height: 210, media: imageSourceBreakpoints.m },
        { width: 386, height: 282, media: imageSourceBreakpoints.l },
      ];

    case articleTeaserSizes.medium:
      return [
        { width: 386, height: 245, media: imageSourceBreakpoints.xs },
        { width: 352, height: 223, media: imageSourceBreakpoints.s },
        { width: 445, height: 282, media: imageSourceBreakpoints.m },
        { width: 590, height: 375, media: imageSourceBreakpoints.l },
      ];

    case articleTeaserSizes.large:
      return [
        { width: 386, height: 220, media: imageSourceBreakpoints.xs },
        { width: 352, height: 200, media: imageSourceBreakpoints.s },
        { width: 445, height: 254, media: imageSourceBreakpoints.m },
        { width: 590, height: 337, media: imageSourceBreakpoints.l },
      ];

    default:
      throw new Error(
        `Unsupported article teaser size: "${teaserSize}". Valid sizes are: ${Object.values(articleTeaserSizes).join(', ')}`
      );
  }
};

const ArticleTeaser = ({
  image,
  heading,
  url,
  size = articleTeaserSizes.small,
  headingTagLevel = 2,
}) => {
  const HeadingTag = `h${headingTagLevel}`;
  return (
    <a
      className={cn('article-teaser', `article-teaser_size_${size}`)}
      href={url}
    >
      {image && (
        <div className="article-teaser__image-holder">
          <Image
            {...image}
            sources={getImageSources(size)}
            loading="lazy"
            className={cn(
              'article-teaser__image',
              `image_size_article-teaser-${size}`
            )}
          />
        </div>
      )}
      <div className="article-teaser__content">
        {heading && (
          <HeadingTag className="article-teaser__heading">
            <span className="article-teaser__heading-text">{heading}</span>
          </HeadingTag>
        )}
        <Icon name="arrow-right" className="article-teaser__icon" />
      </div>
    </a>
  );
};

ArticleTeaser.viewModelMeta = {
  size: 'ignore',
  headingTagLevel: 'ignore',
};

ArticleTeaser.propTypes = {
  image: PropTypes.exact(Image.propTypes),
  heading: PropTypes.string,
  url: PropTypes.string,
  size: PropTypes.oneOf(Object.values(articleTeaserSizes)),
  headingTagLevel: PropTypes.oneOf([2, 3]),
};

export default ArticleTeaser;
